<template>
  <Card class="card supply-chain-service py-16" head title="供应链服务" :more="false">
    <div class="list d-flex align-stretch">
      <div class="item flex-grow-1 flex-shrink-0 d-flex flex-column align-center justify-center" v-for="item in supplyChains" :key="item.id">
        <v-img v-if="item.imgSrc" class="icon mb-4" alt="icon" :src="item.imgSrc"></v-img>
        <div class="text">{{item.text}}</div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/UI/Card'
import SCServiceIcon1 from '@/assets/icons/renzheng.svg'
import SCServiceIcon2 from '@/assets/icons/dinggou.svg'
import SCServiceIcon3 from '@/assets/icons/shangku.svg'
import SCServiceIcon4 from '@/assets/icons/shichang.svg'
export default {
  name: 'SupplyChains',
  components: {
    Card
  },
  data () {
    return {
      supplyChains: [{
        id: 0,
        text: '诚信认证',
        imgSrc: SCServiceIcon1
      }, {
        id: 1,
        text: '商机订购',
        imgSrc: SCServiceIcon2
      }, {
        id: 2,
        text: '合作供应商库',
        imgSrc: SCServiceIcon3
      }, {
        id: 3,
        text: '第三方市场',
        imgSrc: SCServiceIcon4
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.supply-chain-service {
  .list {
    .item {
      width: 20%;
      background-color: #fff;
      padding-top: 30px;
      padding-bottom: 30px;
      .text {
        font-size: 14px;
        font-weight: 500;
        color: #000;
      }
      .icon {
        width: 64px;
        height: 64px;
      }
    }
  }
}
</style>
